
export function ObjectIdCreationDate(objectId) {
  // Extract the timestamp from the ObjectId
  const timestamp = parseInt(objectId.substring(0, 8), 16) * 1000;

  // Convert the timestamp to a date
  const creationDate = new Date(timestamp);
   
  return creationDate;
}